/* ARABELLE – Black Friday (bf.js) */
(function () {
  'use strict';
  var cfg = window.arabelleBF || {};
  var TZ = 'Europe/Bucharest';
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var fmt;
  try {
    fmt = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour12: false, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  } catch (e) { fmt = null; }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function roNow() {
    var d = new Date();
    if (!fmt) return { wd: d.getDay(), h: d.getHours(), m: d.getMinutes(), s: d.getSeconds(), y: d.getFullYear(), mo: d.getMonth() + 1, day: d.getDate() };
    var o = {};
    fmt.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { wd: DAYS.indexOf(o.weekday), h: (+o.hour) % 24, m: +o.minute, s: +o.second, y: +o.year, mo: +o.month, day: +o.day };
  }

  /* ---- Livrare: comanzi până la ora H → primești în următoarea zi lucrătoare ---- */
  var DAYN = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
  function nextBiz(wd) { var d = 1; while ((wd + d) % 7 === 0 || (wd + d) % 7 === 6) d++; return d; }
  function cutoff() {
    var n = roNow();
    var H = +cfg.cutoffHour || 17;
    var biz = n.wd >= 1 && n.wd <= 5;
    var left = H * 3600 - (n.h * 3600 + n.m * 60 + n.s);
    var before = biz && left > 0;
    var shipOff = before ? 0 : nextBiz(n.wd);
    var arriveOff = shipOff + nextBiz((n.wd + shipOff) % 7);
    var arrive = arriveOff === 1 ? 'mâine' : DAYN[(n.wd + arriveOff) % 7];
    var arriveHtml = '<b>' + arrive + '</b>';
    if (before) {
      var h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      var t = h > 0 ? h + 'h ' + pad(m) + 'min' : m + 'min ' + pad(s) + 's';
      return { html: (cfg.cutoffToday || 'Comandă în următoarele [time] și primești coletul [arrive]').replace('[time]', '<time>' + t + '</time>').replace('[arrive]', arriveHtml), urgent: left < 3600 };
    }
    return { html: (cfg.cutoffLater || 'Comandă acum și primești coletul [arrive]').replace('[arrive]', arriveHtml), urgent: false };
  }

  /* ---- Countdown la finalul campaniei ---- */
  var endTs = null;
  if (cfg.end) {
    var mm = String(cfg.end).match(/(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (mm) {
      // ora Romaniei: calculam offset-ul curent RO fata de UTC
      var guess = Date.UTC(+mm[1], +mm[2] - 1, +mm[3], +mm[4], +mm[5]);
      var probe = new Date(guess);
      var ro = fmt ? (function () { var o = {}; fmt.formatToParts(probe).forEach(function (p) { o[p.type] = p.value; }); return Date.UTC(+o.year, +o.month - 1, +o.day, (+o.hour) % 24, +o.minute); })() : guess;
      endTs = guess - (ro - guess);
    }
  }
  function endLeft() {
    if (!endTs) return null;
    var left = Math.max(0, Math.floor((endTs - Date.now()) / 1000));
    var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
    return { left: left, d: d, h: h, m: m, s: s };
  }
  function endHtml(style) {
    var e = endLeft(); if (!e) return '';
    if (style === 'boxes') {
      return '<time>' + (e.d > 0 ? '<span>' + pad(e.d) + '<small>zile</small></span>' : '') + '<span>' + pad(e.h) + '<small>ore</small></span><span>' + pad(e.m) + '<small>min</small></span><span>' + pad(e.s) + '<small>sec</small></span></time>';
    }
    return '<time>' + (e.d > 0 ? e.d + 'z ' : '') + pad(e.h) + ':' + pad(e.m) + ':' + pad(e.s) + '</time>';
  }

  /* ---- Rezervarea cosului ---- */
  var KEY = 'bf_reserve_until', PAGE_LOAD = Date.now();
  function reserveHtml(el) {
    var mins = +el.getAttribute('data-minutes') || 15;
    var until = +localStorage.getItem(KEY) || 0;
    if (!until || until - Date.now() > mins * 60000 || until < PAGE_LOAD) { until = Date.now() + mins * 60000; try { localStorage.setItem(KEY, until); } catch (e) {} }
    var left = Math.max(0, Math.floor((until - Date.now()) / 1000));
    if (left === 0) { el.closest('.bf-reserve') && el.closest('.bf-reserve').classList.add('is-expired'); return cfg.reserveExpired || 'Rezervarea a expirat. Finalizează acum ca să nu pierzi prețul.'; }
    return (cfg.reserveText || 'Produsele tale sunt rezervate [time]').replace('[time]', '<time>' + pad(Math.floor(left / 60)) + ':' + pad(left % 60) + '</time>');
  }

  function tick() {
    var c = null;
    document.querySelectorAll('[data-bf-cutoff]').forEach(function (el) {
      if (!c) c = cutoff();
      if (el.getAttribute('data-last') !== c.html) { el.innerHTML = c.html; el.setAttribute('data-last', c.html); }
      var wrap = el.closest('.bf-cut, .bf-ticker__cut, .bf-hero__cut');
      if (wrap) wrap.classList.toggle('is-urgent', c.urgent);
    });
    document.querySelectorAll('[data-bf-end]').forEach(function (el) {
      var html = endHtml(el.getAttribute('data-bf-end'));
      if (html && el.innerHTML !== html) el.innerHTML = html;
      var e = endLeft();
      if (e && e.left === 0) { var w = el.closest('[data-bf-end-wrap]'); if (w) w.hidden = true; }
    });
    document.querySelectorAll('[data-bf-reserve]').forEach(function (el) { var h = reserveHtml(el); if (el.innerHTML !== h) el.innerHTML = h; });
  }
  tick();
  setInterval(tick, 1000);

  // cosul gol -> resetam rezervarea
  document.addEventListener('arabelle:cart', function (e) { try { if (e.detail && e.detail.item_count === 0) localStorage.removeItem(KEY); } catch (x) {} });

  /* ---- Ticker: dublam pista pentru loop continuu ---- */
  document.querySelectorAll('.bf-ticker__track, .bf-marquee__track').forEach(function (t) {
    if (t.getAttribute('data-dup')) return;
    var unit = t.innerHTML, wrap = t.parentElement, need = (wrap ? wrap.clientWidth : window.innerWidth) || window.innerWidth;
    // repetă conținutul până când o „unitate” acoperă cel puțin lățimea vizibilă, apoi dublează pentru loop (-50%)
    var html = unit, guard = 0;
    t.innerHTML = html;
    while (t.scrollWidth < need + 40 && guard < 20) { html += unit; t.innerHTML = html; guard++; }
    t.innerHTML = html + html;
    var speed = t.classList.contains('bf-marquee__track') ? 170 : 120; // px/s
    var secs = Math.max(8, Math.round(t.scrollWidth / 2 / speed));
    t.style.animationDuration = secs + 's';
    t.setAttribute('data-dup', '1');
  });

  /* ---- Exit intent ---- */
  var modal = document.getElementById('BFExit');
  if (modal && cfg.exitCode) {
    var SKEY = 'bf_exit_shown', opened = false, start = Date.now(), exitUntil = 0;
    var seen = false; try { seen = sessionStorage.getItem(SKEY) === '1'; } catch (e) {}
    var timerEl = modal.querySelector('[data-bf-exit-timer]');
    function exitTick() {
      if (!opened) return;
      var left = Math.max(0, Math.floor((exitUntil - Date.now()) / 1000));
      if (timerEl) timerEl.innerHTML = '<time>' + pad(Math.floor(left / 60)) + ':' + pad(left % 60) + '</time>';
      if (left > 0) setTimeout(exitTick, 1000);
    }
    function open() {
      if (opened || seen) return;
      if (document.querySelector('.drawer.is-open, .search-modal.is-open')) return;
      opened = true; seen = true; try { sessionStorage.setItem(SKEY, '1'); } catch (e) {}
      exitUntil = Date.now() + (+cfg.exitMinutes || 15) * 60000;
      modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      exitTick();
      var f = modal.querySelector('.bf-exit__copy, .bf-exit__close'); if (f) f.focus();
    }
    function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    modal.querySelectorAll('[data-bf-exit-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    var copy = modal.querySelector('.bf-exit__copy');
    if (copy) copy.addEventListener('click', function () {
      var done = function () { copy.classList.add('is-done'); copy.textContent = cfg.copied || 'Copiat ✓'; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(cfg.exitCode).then(done, done); else done();
    });
    var coarse = window.matchMedia && window.matchMedia('(pointer:coarse)').matches;
    if (!coarse) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0 && Date.now() - start > 4000) open();
      });
    } else if (cfg.exitMobileDelay > 0 && (cfg.template === 'product' || cfg.template === 'cart' || cfg.template === 'collection')) {
      setTimeout(open, cfg.exitMobileDelay * 1000);
    }
  }
})();

/* ---- Bara fixă jos ---- */
(function () {
  var bar = document.querySelector('[data-bf-sticky]');
  if (!bar) return;
  var KEY = 'bf_sticky_closed', closed = false;
  try { closed = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
  if (closed) { bar.remove(); return; }
  var shown = false;
  function check() {
    var y = window.scrollY || document.documentElement.scrollTop;
    var want = y > 420;
    if (want !== shown) { shown = want; bar.classList.toggle('is-visible', want); document.body.classList.toggle('bf-has-sticky', want); }
  }
  window.addEventListener('scroll', check, { passive: true }); check();
  var c = bar.querySelector('[data-bf-sticky-close]');
  if (c) c.addEventListener('click', function () { bar.classList.remove('is-visible'); document.body.classList.remove('bf-has-sticky'); try { sessionStorage.setItem(KEY, '1'); } catch (e) {} setTimeout(function () { bar.remove(); }, 400); });
})();
